import { hashString } from '@framework/data-helpers/string/hashString';

export interface CacheEntry {
  value: unknown,
  expiresAt: number,
}

export function buildCacheKey(scope: string, method: string, args: unknown[]): string {
  return `${ scope }.${ method }.${ hashString(JSON.stringify(args)) }`;
}

export function getCached(cache: Map<string, CacheEntry>, cacheKey: string): unknown | undefined {
  const cached = cache.get(cacheKey);

  if (cached && Date.now() < cached.expiresAt) {
    return cached.value;
  }

  return undefined;
}

export function setCache(
  cache: Map<string, CacheEntry>,
  cacheKey: string,
  value: unknown,
  ttlMs: number,
  maxEntries: number = Infinity,
): void {
  cache.delete(cacheKey);
  cache.set(cacheKey, { value, expiresAt: Date.now() + ttlMs });

  while (cache.size > maxEntries) {
    cache.delete(cache.keys().next().value);
  }
}

export function cachePromiseWithEviction<T>(
  promise: Promise<T>,
  cache: Map<string, CacheEntry>,
  cacheKey: string,
): Promise<T> {
  return promise.catch((error: unknown) => {
    cache.delete(cacheKey);
    throw error;
  });
}
